import { render, staticRenderFns } from "./TagButton.vue?vue&type=template&id=7851ddb1&scoped=true"
import script from "./TagButton.vue?vue&type=script&lang=js"
export * from "./TagButton.vue?vue&type=script&lang=js"
import style0 from "./TagButton.vue?vue&type=style&index=0&id=7851ddb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7851ddb1",
  null
  
)

export default component.exports